  /*============Find A Dealer Form Controller
  ================================*/
  angular
      .module('vppApp')
      .controller('findDealerFormController', findDealerFormController);

  findDealerFormController.$inject = ['$scope', '$http', '$state', 'apiFactory', 'FindDealerResultsService', '$stateParams', 'vppConfig', 'SetLiveSwapService', 'DealerBrandService'];

    function findDealerFormController($scope, $http, $state, apiFactory, FindDealerResultsService, $routeParams, vppConfig, SetLiveSwapService, DealerBrandService){
      console.log('findDealerFormController()');
      var liveswap = SetLiveSwapService.getLSBrandName();
      var lsbrand = vppConfig.lsBrands[liveswap];
      var dealerBrand;
      $scope.searchBy = 'zip';
      $scope.range = '25';
      if(liveswap){
        $scope.showBrand = lsbrand;
        $scope.liveSwap = true;
      }
      

      $scope.submit = function() {

        var searchBy = $scope.searchBy;
        var getParams = '';

        switch(searchBy) {
          case 'zip':
            getParams = $scope.make + '/' + $scope.zip + '/' + $scope.range;
            break;
          case 'citystate':
            getParams = $scope.make + '/' + $scope.city + '/' + $scope.state + '/' + $scope.range;
            // getParams = '/MAKE/CITY/STATE/RANGE';
            break;
        }

        // console.log('data', sendData);

        apiFactory.findDealerForm(getParams)
            .then(function successSignOut(response) {
              // console.log('response.data', response.data);
              dealerBrand = $scope.make;
              response.data.mapInit = {
                zip: $scope.zip,
                range: $scope.range
              };
              DealerBrandService.addDBrand(dealerBrand);
              FindDealerResultsService.set(response.data);
              $state.go("shopping-tools.find-dealer-results", null, {reload:true});
              // this callback will be called asynchronously
              // when the response is available
            }, function errorCallback(response) {
              console.log(response.data.errors);
              $scope.serverError = response.data.errors;
              // called asynchronously if an error occurs
              // or server returns response with an error status.
              response.data.mapInit = {
                zip: $scope.zip,
                range: $scope.range
              };

              FindDealerResultsService.set({
                mapInit: {
                  zip: $scope.zip,
                  range: $scope.range
                },
                dealerResultsVO: []
              });

              $state.go("shopping-tools.find-dealer-results");
            });
      };
  };